<template>
	<tbody v-if="msgError != null || ajax">
		<tr v-for="(erro, index) in msgError" :key="index">
			<td class="text-center bg-danger" :colspan="colspan">
				<i class="fa fa-close"></i>
				{{ erro }}
			</td>
		</tr>
		<tr v-if="ajax != null && ajax.length == 0 && msgError == null">
			<td class="text-center" :colspan="colspan">
				<i class="fa fa-warning"></i>
				Nenhum registro encontrado!
			</td>
		</tr>
		<tr v-if="ajax == null && msgError == null">
			<td class="text-center" :colspan="colspan">
				<i class="fa fa-spin fa-spinner"></i>
				Nenhum registro encontrado!
			</td>
		</tr>
	</tbody>
</template>
<script>
	export default {
		name: 'AppMsgErrorLoadTb',
		props: ['msgError', 'colspan', 'ajax'],
	};
</script>



// WEBPACK FOOTER //
// src/app-components/table/tb-msg-error.vue